var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 10.9829C14.3418 10.9829 16.2407 9.08397 16.2407 6.74147C16.2407 4.39897 14.3418 2.5 11.9993 2.5C9.65678 2.5 7.75781 4.39897 7.75781 6.74147C7.75781 9.08397 9.65678 10.9829 11.9993 10.9829Z",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66797 18.5336C3.66797 15.7721 5.90654 13.5336 8.66797 13.5336H15.3339C18.0953 13.5336 20.3339 15.7721 20.3339 18.5336V20.5C20.3339 21.0522 19.8861 21.5 19.3339 21.5H4.66797C4.11568 21.5 3.66797 21.0522 3.66797 20.5V18.5336Z",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser24Px);
export default __webpack_public_path__ + "static/media/User_24px.80133d2832a08aafcf6b804601f952cd.svg";
export { ForwardRef as ReactComponent };